// Workouts.jsx
import React, { useState, useEffect } from "react";
import { Flame, Dumbbell, Sparkles, LayoutGrid } from "lucide-react";
import "./Workouts.css";

const sliderImages = [
  { src: "/assets/img/rutinas.webp", alt: "Rutinas de entrenamiento en Wayo" },
  { src: "/assets/img/calenario-rutinas.webp", alt: "Calendario de rutinas en Wayo" },
  { src: "/assets/img/detalle-rutinas.webp", alt: "Detalle de rutina en Wayo" },
];

export default function Workouts() {
  const [current, setCurrent] = useState(0);
  const touchStartX = React.useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % sliderImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      setCurrent(c =>
        diff > 0
          ? (c + 1) % sliderImages.length
          : (c - 1 + sliderImages.length) % sliderImages.length
      );
    }
    touchStartX.current = null;
  };

  // El color de cada icono acompaña al de su card (ver .workout-card-modern:nth-child)
  const workoutPlans = [
    {
      id: 1,
      title: "Adelgazar",
      Icon: Flame,
      color: "#fbbf24",
      description: "Quema grasa en casa o en el gym. Sin excusas.",
    },
    {
      id: 2,
      title: "Ganar Músculo",
      Icon: Dumbbell,
      color: "#a78bfa",
      description: "Fuerza e hipertrofia para ganar volumen y definición.",
    },
    {
      id: 3,
      title: "Tonificar",
      Icon: Sparkles,
      color: "#34d399",
      description: "Menos grasa, más músculo. Resultados visibles.",
    },
    {
      id: 4,
      title: "+50 Rutinas",
      Icon: LayoutGrid,
      color: "#60a5fa",
      description: "Tren superior, inferior, fullbody y más. Para todos los niveles.",
    }
  ];

  return (
    <section id="workouts" className="workouts">
      <div className="workouts-container">

        {/* Header */}
        <div className="workouts-header">
          <span className="workouts-badge">Entrenamientos</span>
          <h2 className="workouts-title">
            Rutinas para cada <span className="title-highlight">objetivo</span>
          </h2>
          <p className="workouts-description">
            Entrenamientos personalizados para casa o gimnasio. Desde principiante hasta avanzado,
            con videos paso a paso.
          </p>
        </div>

        {/* Cards */}
        <div className="workouts-cards-col">
          {workoutPlans.map((plan) => (
            <article key={plan.id} className="workout-card-modern">
              <div className="workout-card-top">
                <span className="workout-icon-modern" style={{ color: plan.color }}>
                  <plan.Icon size={20} strokeWidth={2} aria-hidden="true" />
                </span>
                <h3 className="workout-title-modern">{plan.title}</h3>
              </div>
              <p className="workout-description-modern">{plan.description}</p>
            </article>
          ))}
        </div>

        {/* Slider */}
        {/* Slider — solo móvil */}
        <div className="workouts-image-col workouts-mobile-only">
          <div
            className="workouts-slider"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className="workouts-slider-track"
              style={{ transform: `translateX(-${current * 100}%)` }}
            >
              {sliderImages.map((img, i) => (
                <img key={i} src={img.src} alt={img.alt} className="workouts-phone-img" />
              ))}
            </div>
          </div>
          <div className="workouts-slider-dots">
            {sliderImages.map((_, i) => (
              <button
                key={i}
                className={`workouts-dot${i === current ? " workouts-dot--active" : ""}`}
                onClick={() => setCurrent(i)}
                aria-label={`Imagen ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* 3 imágenes en grid — solo escritorio */}
        <div className="workouts-desktop-imgs">
          {sliderImages.map((img, i) => (
            <div key={i} className="workouts-desktop-img-card">
              <img src={img.src} alt={img.alt} className="workouts-desktop-img" />
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="stats-section2">
          <div className="stat-item2">
            <div className="stat-number">+50</div>
            <div className="stat-label">Rutinas disponibles</div>
          </div>
          <div className="stat-item2">
            <div className="stat-number">15-60min</div>
            <div className="stat-label">Duraciones flexibles</div>
          </div>
          <div className="stat-item2 stat-item-highlight2">
            <div className="stat-number">Casa o Gym</div>
            <div className="stat-label">Entrena donde quieras</div>
          </div>
        </div>

      </div>
    </section>
  );
}
